import { BuildingReferenceFilterFormData } from "entities/building-references/types/BuildingReferenceFilterFormData"
import { map } from "nanostores"

const defaultState: BuildingReferenceFilterFormData = {
  searchTerm: null,
  products: null,
  buildingTypes: null
}

// Deliberately not persisted, see portfolio-filter-store.
export const buildingReferenceFilterStore =
  map<BuildingReferenceFilterFormData>(defaultState)

export function setFilterState(state: BuildingReferenceFilterFormData) {
  buildingReferenceFilterStore.set(state)
}

export function updateFilterState(
  updates: Partial<BuildingReferenceFilterFormData>
) {
  const currentState = buildingReferenceFilterStore.get()
  buildingReferenceFilterStore.set({ ...currentState, ...updates })
}

export function resetFilterState() {
  buildingReferenceFilterStore.set(defaultState)
}
